import type { ReactElement } from 'react';
import { Text } from '@/components/Text/Text';

const StoreButtonToolTip = (): ReactElement => (
  <div className="store-tooltip">
    <Text>Launches a store so people can:</Text>
    <ul>
      <li>
        <img src="/src/assets/svg/tick.svg" alt="Icon" /> Enter their own quantity and sizes
      </li>
      <li>
        <img src="/src/assets/svg/tick.svg" alt="Icon" /> Pay directly
      </li>
      <li>
        <img src="/src/assets/svg/tick.svg" alt="Icon" /> Have items shipped to their homes
      </li>
    </ul>
  </div>
);

StoreButtonToolTip.displayName = 'StoreButtonToolTip';

export default StoreButtonToolTip;
